module.exports = __webpack_public_path__ + "img/jose-hero-alt.ac168b96.png";